<form [formGroup]="form" novalidate (ngSubmit)="onSubmitForm()" [style.backgroundImage]="'url('+ getRandomBackground() +')'">
  <div fxLayout="row" fxLayoutAlign="center center">
    <mat-card>
      <mat-card-title>
        <div class="center title">
          <img src="assets/logo_.png" alt="Logo" id="header-logo" class="center">
          <p class="center title-text">Wachtwoord Aanmaken</p>
          <p class="center content-text">Voer een nieuw wachtwoord in om in te kunnen loggen met uw account</p>
        </div>
      </mat-card-title>
      <mat-card-content>
        <div class="center content">
          @if (formError) {
            <p class="error-message">
              <mat-icon>error_outline</mat-icon> {{formError}}
            </p>
          }
          <p>
            <mat-form-field>
              <mat-label>Wachtwoord</mat-label>
              <input type="{{showPassword ? 'text' : 'password'}}" matInput
                formControlName="Password">
                <button type="button" matSuffix mat-icon-button title="{{showPassword ? 'Toon' : 'Verberg'}}"
                  (click)="showPassword = !showPassword">
                  <mat-icon>{{showPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                </button>
              </mat-form-field>
            </p>
            <button mat-button type="submit" class="submit-button" [disabled]="form.invalid">Activeer</button>

          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </form>